import { render, staticRenderFns } from "./RequirePasswordForLearnersForm.vue?vue&type=template&id=64c3a85a&scoped=true"
import script from "./RequirePasswordForLearnersForm.vue?vue&type=script&lang=js"
export * from "./RequirePasswordForLearnersForm.vue?vue&type=script&lang=js"
import style0 from "./RequirePasswordForLearnersForm.vue?vue&type=style&index=0&id=64c3a85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3a85a",
  null
  
)

export default component.exports